export enum SidebarItems {
  Home = "Home",
  Tasks = "Tasks",
  Companies = "Companies",
  Forms = "Forms",
}
